import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const H4: Components["h4"] = ({ children, className, ...rest }) => (
  <h4
    className={cn("af-text-md af-m-0 af-pt-6 af-font-bold", className)}
    {...rest}
  >
    {children}
  </h4>
);
